"use strict";
const collectionFunctions = require('../../interfaces/orderAndInvoiceRows/collections');
const propertiesFunctions = require('../../interfaces/orderAndInvoiceRows/properties');
const alcTaxAdjustmentsFunctions = require('../../interfaces/orderAndInvoiceRows/alcTaxAdjustments');
const srsFunctions = require('./SRS');
module.exports = {
    ...collectionFunctions,
    ...propertiesFunctions,
    ...alcTaxAdjustmentsFunctions,
    ...srsFunctions,
};
